import React from "react";
import {createUseStyles, useTheme} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {Theme} from "engage-client/theme";

const useStyles = createUseStyles<Theme>((theme) => ({
    playerDisplay: {
        height: 30,
        background: theme.accessoryPanel.dashBoard.simpleDashboard ? theme.accessoryPanel.background : "transparent linear-gradient(180deg, #334476 0%, #2F4666D0 100%) 0% 0% no-repeat padding-box",
        width: "100%",
        display: "flex",
        alignItems: "center",
        marginTop: 15,
        justifyContent: theme.accessoryPanel.dashBoard.simpleDashboard ? "center" : "normal",
        borderRadius: theme.accessoryPanel.dashBoard.simpleDashboard ? 12 : 0,
        [theme.breakpoints.up("xxl")] : {
            marginTop: "1vh",
            height: "4vh",
            borderRadius: theme.accessoryPanel.dashBoard.simpleDashboard ? 30 : 0,
        }
    },
    playerIcon: {
        width: 25,
        height: 25,
        marginLeft: 5,
        marginRight: 5
    },
}));

type HostPlayerDisplayProps = {
    name: string
}

const HostPlayerDisplay = ({name}:HostPlayerDisplayProps) => {
    
    const classes = useStyles();
    const theme:Theme = useTheme();
    
    return (
        <div className={classes.playerDisplay}>
            {!theme.accessoryPanel.dashBoard.simpleDashboard && <img src="/assets/icons/common/player.svg" className={classes.playerIcon}/>}
            <DisplayText variant={TextVariant.s16reg} color="white">{name}</DisplayText>
        </div>
    );
    
};

export default HostPlayerDisplay;